import { fetchWithRetry } from "../client";
import { Memorias } from "./types";
import { cmsLang, type Locale } from "@/i18n/config";

export async function fetchMemorias(lang: Locale): Promise<Memorias[]> {
  const res = await fetchWithRetry<{ data: Memorias[] }>(
    `/transparencia/memorias-anuales?lang=${cmsLang(lang)}`,
  );
  return res.data;
}
